function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCompany(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 23,
    viewBox: "0 0 22 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M21.166 21.4023H1.16602",
    stroke: "#1A4338",
    style: {
      stroke: "#1A4338",
      stroke: "color(display-p3 0.1020 0.2627 0.2196)",
      strokeOpacity: 1
    },
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.17 4.40234C10.188 3.16234 10.28 2.45934 10.752 1.98834C11.338 1.40234 12.28 1.40234 14.166 1.40234H16.166C18.052 1.40234 18.994 1.40234 19.58 1.98834C20.166 2.57434 20.166 3.51634 20.166 5.40234V21.4023H14.166M14.166 21.4023V8.40234C14.166 6.51634 14.166 5.57434 13.58 4.98834C12.994 4.40234 12.052 4.40234 10.166 4.40234H6.16602C4.28002 4.40234 3.33802 4.40234 2.75202 4.98834C2.16602 5.57434 2.16602 6.51634 2.16602 8.40234V21.4023H14.166Z",
    stroke: "#1A4338",
    style: {
      stroke: "#1A4338",
      stroke: "color(display-p3 0.1020 0.2627 0.2196)",
      strokeOpacity: 1
    },
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.16602 21.4023V18.4023M5.16602 7.40234H11.166M5.16602 10.4023H11.166M5.16602 13.4023H11.166",
    stroke: "#1A4338",
    style: {
      stroke: "#1A4338",
      stroke: "color(display-p3 0.1020 0.2627 0.2196)",
      strokeOpacity: 1
    },
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompany);
export default __webpack_public_path__ + "static/media/company.2a0f1bc0f994f056cbe1ccfaebd7b708.svg";
export { ForwardRef as ReactComponent };